// Product Image Gallery - Desktop Scroll + Sticky Thumbnails
// Scrolls body to image on thumbnail click, updates active thumbnail on scroll

(function () {
  function scrollToImage(index) {
    var gallery = document.querySelector(".image-gallery");
    if (!gallery) return;

    var wrappers = gallery.querySelectorAll(".image-wrapper");
    if (index < 0 || index >= wrappers.length) return;

    var target = wrappers[index];
    target.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  window.scrollToImage = scrollToImage;

  document.addEventListener("DOMContentLoaded", function () {
    var gallery = document.querySelector(".image-gallery");
    if (!gallery) return;

    var wrappers = gallery.querySelectorAll(".image-wrapper");
    var thumbnails = document.querySelectorAll(
      ".product-image-gallery .product-thumbnail",
    );

    // Remove skeleton when each image finishes loading
    thumbnails.forEach((thumb) => {
      const media = thumb.querySelector("img");
      if (!media) return;

      const done = () => thumb.classList.remove("is-loading");

      if (media.complete) {
        done();
      } else {
        media.addEventListener("load", done, { once: true });
        media.addEventListener("error", done, { once: true });
      }
    });

    if (wrappers.length === 0 || thumbnails.length === 0) return;

    // Mark first thumbnail as active
    thumbnails[0].classList.add("active");

    // Scroll spy: update active thumbnail based on which image is in view
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var idx = parseInt(
              entry.target.getAttribute("data-image-index"),
              10,
            );
            for (var j = 0; j < thumbnails.length; j++) {
              thumbnails[j].classList.remove("active");
            }
            if (thumbnails[idx]) {
              thumbnails[idx].classList.add("active");
              thumbnails[idx].scrollIntoView({
                behavior: "smooth",
                block: "nearest",
              });
            }
          }
        });
      },
      {
        root: null,
        rootMargin: "-30% 0px -30% 0px",
        threshold: 0,
      },
    );

    for (var i = 0; i < wrappers.length; i++) {
      observer.observe(wrappers[i]);
    }
  });
})();
